export default __webpack_public_path__ + "static/media/img11.adce99db.png";